
import { Component, Vue, Prop, Emit } from "vue-property-decorator"
import { State, Getter } from "vuex-class"

import vSelect from "vue-select"

import { Team, CaseUser, User } from "@/types"

import api from "@/services/api"
import { CurrentUser } from "@/types/user"
import AddExternalUser from "./AddExternalUser.vue"
import { ExternalUser } from "@/types/externalUser"

	@Component({
		components: {
			"v-select": vSelect,
			"add-external-user": AddExternalUser
		}
	})
export default class UserSearch extends Vue {
	@Prop()
	public currentCase: any;

	@Prop({ default: true })
	searchTeams!: boolean;

	@Prop({ default: false })
	isExternalUser!: boolean;

	@Prop({ default: false })
	showTeamFilter!: boolean;

	@Prop({ default: () => [] })
	existingUserIds!: string[];

	@Prop({ default: () => [] })
	allowedTeamsIds!: string[];

	@Prop({ default: true })
	disallowAdded!: boolean

	@Prop({ default: false })
	allowAddSelf!: boolean;

	@Prop({ default: () => [] })
	filteredOutUsers!: CaseUser[] | User[]

	@Prop({ type: Boolean, default: false })
	excludeInactiveUsers!: boolean

	@State public teams!: Team[];

	@Getter("getMe") public me!: CurrentUser;

	private inviteUsers: User[] | ExternalUser | any[] = [];
	private selectedItem: User | ExternalUser | any = null;
	private teamFilter: string | null = null;

	get filterTeams (): Team[] {
		if (!this.allowedTeamsIds || this.allowedTeamsIds.length === 0) return this.teams
		return this.teams.filter(t => this.allowedTeamsIds.indexOf(t.id) > -1)
	}

	get enableTeamFilter () {
		return this.showTeamFilter && this.filterTeams.length > 1
	}

	public async fetchOptions (search: string, loading: (isLoading: boolean) => void) {
		if (search === "") {
			this.inviteUsers = []
		} else {
			loading(true)

			try {
				this.inviteUsers = (this.currentCase
					? await api.searchInvite(this.currentCase.id, search,
						this.teamFilter
							? [this.teamFilter]
							: this.allowedTeamsIds && this.allowedTeamsIds.length > 0 ? this.allowedTeamsIds : null,
						this.searchTeams,
						this.disallowAdded)
					: await api.searchUsers(search, this.teamFilter, this.allowedTeamsIds && this.allowedTeamsIds.length > 0 ? this.allowedTeamsIds : null))
					.filter((user: User) => this.shouldUserBeIncluded(user))
			} finally {
				loading(false)
			}
		}
	}

	private shouldUserBeIncluded (user: any): boolean {
		if (!this.allowAddSelf && user.id === this.me.id) {
			return false
		}

		if (this.excludeInactiveUsers && user.disabled) {
			return false
		}

		return this.existingUserIds.indexOf(user.id) === -1 &&
			this.filteredOutUsers.findIndex((filteredUser: any) => user.id === filteredUser.id) === -1
	}

	public userPicture (inviteSearchResult: any): string {
		if (inviteSearchResult.isTeam) {
			return ""
		} else if (inviteSearchResult.imageUrl) {
			return inviteSearchResult.imageUrl!
		} else if (inviteSearchResult.pictureUrl) {
			return inviteSearchResult.pictureUrl!
		} else {
			return api.pictureUrl(inviteSearchResult.id)
		}
	}

	@Emit("selected")
	public async addUser (inviteSearchResult: any) {
		if (inviteSearchResult.isExternal) {
			inviteSearchResult.id = await api.generateID()
		}
		return inviteSearchResult
	}

	public loadedImage (_result: any) {
		// do nothing here - this is just a handler to tell the browser not to show it until it's loaded
	}

	get appendDropdownToBody () {
		return this.currentCase === undefined || this.currentCase === null // Custom styling to fix dropdown list visibility issue when the parent component is not a case
	}
}
